import type { IconComponent } from '../icons';
import { BookIcon, ChartIcon, HomeIcon, InboxIcon, LedgerIcon, MoreIcon } from '../icons';
import { NAV } from '../strings';

export interface NavItem {
  to: string;
  label: string;
  icon: IconComponent;
  /** Show the open-inbox count. */
  badge?: 'inbox';
  /** Exact match only (Hem). */
  end?: boolean;
}

/** Desktop / rail primary navigation, in order. */
export const PRIMARY_NAV: readonly NavItem[] = [
  { to: '/hem', label: NAV.home, icon: HomeIcon, end: true },
  { to: '/att-gora', label: NAV.inbox, icon: InboxIcon, badge: 'inbox' },
  { to: '/handelser', label: NAV.events, icon: LedgerIcon },
  { to: '/rapporter', label: NAV.reports, icon: ChartIcon },
  { to: '/mer', label: NAV.more, icon: MoreIcon },
];

/** Mobile bottom tabs: Hem · Att göra · (+) · Rapporter · Mer. Händelser lives in Mer. */
export const MOBILE_TABS_LEFT: readonly NavItem[] = [PRIMARY_NAV[0]!, PRIMARY_NAV[1]!];
export const MOBILE_TABS_RIGHT: readonly NavItem[] = [PRIMARY_NAV[3]!, PRIMARY_NAV[4]!];

/** Advanced-mode "Bokföring" group. `bokslut` needs the current fiscal year id. */
export function bookkeepingNav(currentFiscalYearId: string | undefined): readonly { to: string; label: string }[] {
  return [
    { to: '/rapporter/verifikationslista', label: NAV.journal },
    { to: '/rapporter/huvudbok', label: NAV.generalLedger },
    { to: '/rapporter/rabalans', label: NAV.trialBalance },
    { to: '/rapporter/kontoplan', label: NAV.chartOfAccounts },
    { to: '/rapporter/handelselogg', label: NAV.eventLog },
    { to: '/rapporter/sie', label: NAV.sie },
    ...(currentFiscalYearId ? [{ to: `/bokslut/${currentFiscalYearId}`, label: NAV.yearEnd }] : []),
    { to: '/lagg-till/verifikation', label: NAV.newVerifikation },
  ];
}

export const BOOKKEEPING_ICON: IconComponent = BookIcon;
